import PropTypes from "prop-types";
import React from "react";
import Flux from "../../flux/Flux";
import FeedPostInput from "./FeedPostInput";
import VXButton from "../SimpleElements/VXButton/VXButton";
import { COLOR_TYPE_SPECIAL } from "../SimpleElements/VXButton/ButtonHelper";
import { VXButtonLineConfig } from "../SimpleElements/VXButton/VXButtonConfig";
import STYLES from "../SimpleElements/VXButton/EnumVXButton";
import { postCommentType, REPLY_SIGN } from "./FeedHelper";
import { getCommonTranslation } from "../../utils/TranslationHelper";
import FeedPostCommentTile from "./FeedPostCommentTile";
import Translations from '../../utils/Translations';
import { VXPay } from "../../utils/VXPay";
import FeedPostStats from "./FeedPostStats";

class FeedPostComments extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			showComments:    false,
            selectedComment: null,
			selectedCommentToggle: false,
		};

		this.onCommentClick = this.onCommentClick.bind(this);
		this.onClickReply   = this.onClickReply.bind(this);

        this.inputRef = null;
		this.listRef  = null;
	}

	componentDidUpdate() {
		if (this.listRef) {
			//this.listRef.scrollTop = 0;
		}
	}

    onClickReply(e, comment) {
        e.preventDefault();
        this.setState({selectedComment: comment, selectedCommentToggle: !this.state.selectedCommentToggle});
        this.inputRef.areaRef.focus();
    }

	isValidAnswer(item) {
		const name = item.replace(REPLY_SIGN, '');
		return this.props.comments.nodes && this.props.comments.nodes.find(comment => comment.replies.find(reply => reply.user.name === name));
	}

	onCommentClick() {
		const isTablet  = (Flux.Browser.isTablet() && Flux.Browser.isPortrait());

		if (this.props.isMobile || isTablet) {
			Flux.Feed.toggleOverlay(this.props.id, Flux.Constants.Feed.OverlayTypes.COMMENTS);
		} else {
			Flux.Feed.toggleOverlay(this.props.id, Flux.Constants.Feed.OverlayTypes.ALL);
		}
	}

	onClickLogin(e) {
		e.preventDefault();
		VXPay.openSignupOrLogin();
	}

	getFooterComment(comment) {
		return <div className="feed-comment">
		<div className="">
			<FeedPostCommentTile comment={comment} showReplyText={false} comments={this.props.comments} hasAvs={this.props.hasAvs} />
			</div>
	</div>;
	}

	render() {
		const comments     = [...this.props.comments.nodes];
		const hasComments  = this.props.comments.totalCount > 0 && comments.length > 0;

		return (
			<div className="feed-comment__wrapper">
				{ !this.props.isOverlay && (
					this.props.guestComment ? this.getFooterComment(this.props.guestComment) :
					(hasComments ? this.getFooterComment(comments[0].comment) : null))
				}
				<div className={"feed-comments" + (this.props.isOverlay ? " feed-comments--overlay" : "")}>
					{Flux.Guest.isLoggedIn() && (this.props.guestComment ? this.props.comments.totalCount > 1 : hasComments) && !this.props.isOverlay && (
						<button className="feed-comments-more" onClick={this.onCommentClick}>
							{this.props.comments.totalCount === 1 ?
								getCommonTranslation('show-n-comment', this.props.comments.totalCount) :
								getCommonTranslation('show-n-comments', this.props.comments.totalCount)
							}
						</button>
					)}

					{(this.state.showComments || this.props.isOverlay) && (
						<div className="feed-comments-list__wrapper">
							<div className={"feed-comments-list" + (this.props.isOverlay && !hasComments ? " feed-comments-list--flex" : "")} ref={ref => this.listRef = ref}>{hasComments && comments.map((item, index) => (
							<FeedPostCommentTile key={index} comment={item.comment} replies={item.replies} showReplyText={true} onClickReply={this.onClickReply} postId={this.props.id} comments={this.props.comments} hasAvs={this.props.hasAvs}/>))}
							{this.props.isOverlay && !hasComments && <React.Fragment>
									<span className="feed-comments-list__empty-headline">{getCommonTranslation('no-comments-yet')}</span>
									<span className="feed-comments-list__empty-subline">{getCommonTranslation('be-first-comment')}</span>
								</React.Fragment>}
							</div>
						</div>
					)}
					{this.props.isOverlay && <FeedPostStats {...this.props} canLike={this.props.canLike} onlyLike={true}/>}
					<div className="feed-comment-add__wrapper">
						{this.props.canLike && <FeedPostInput ref={ref => this.inputRef = ref} id={this.props.id} selectedComment={this.state.selectedComment} selectedCommentToggle={this.state.selectedCommentToggle} hasAvs={this.props.hasAvs} />}
						{!Flux.Guest.isLoggedIn() && this.props.isOverlay && (
							<div className="h-mt-10 h-text-align-center ">
								<VXButton
									color={COLOR_TYPE_SPECIAL}
									line1={[new VXButtonLineConfig(Translations.get('SignupForFree').toLocaleUpperCase())]}
									onClick={this.onClickLogin}
									size={STYLES.SIZE.FULL}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

FeedPostComments.propTypes = {
	isOverlay:      PropTypes.bool,
	hasLiked:       PropTypes.bool,
	isMobile:       PropTypes.bool,
	comments:       PropTypes.shape(postCommentType),
	id:             PropTypes.string.isRequired,
	hasAvs:         PropTypes.bool,
	canLike:        PropTypes.bool,
	guestComment:   PropTypes.object,
};

FeedPostComments.defaultProps = {
	comments:  [],
	isMobile:  false,
    isOverlay: false,
	hasAvs:    false,
	canLike:   false,
	guestComment: null,
};

export default FeedPostComments;
